import { render } from "./HomeDetailPage.vue?vue&type=template&id=522c8376&scoped=true"
import script from "./HomeDetailPage.vue?vue&type=script&lang=js"
export * from "./HomeDetailPage.vue?vue&type=script&lang=js"

import "./HomeDetailPage.vue?vue&type=style&index=0&id=522c8376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522c8376"]])

export default __exports__